import{a as i}from"./ninox-components-ED6G4JEG.js";import{a}from"./ninox-components-ZXBPGGT2.js";import{l}from"./ninox-components-GQTCIGTF.js";import{m as o}from"./ninox-components-2ADN25D5.js";import{k as e}from"./ninox-components-R4FVH3NU.js";import{a as t}from"./ninox-components-I2GBTDK4.js";import r from"styled-components";var m=r.div`
    display: flex;
    flex-direction: column;
    padding: ${o.medium};
    gap: ${o.x_small};

    --_color-swatch-size: var(--color-swatch-size, calc(${l.m}));

    & > * {
        --color-swatch-size: var(--_color-swatch-size);
    }
`,g=r.div`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    line-height: 1;
`,x=r.header`
    color: ${({theme:c})=>c.text.secondary};
    font-weight: ${t.normal};
    font-size: ${e.medium};
`,w=r(a)`
    display: flex;
    flex-flow: row wrap;

    --_color-picker-grid-gap: var(--color-picker-grid-gap, ${o.xx_small});

    box-sizing: content-box;
    min-width: 100%;
    max-width: 100%;
    width: calc(
        var(--color-picker-columns, 6) * var(--color-swatch-size) + (var(--color-picker-rows, 6) - 1) *
            var(--_color-picker-grid-gap) + ${o.small}
    );
    max-height: calc(
        var(--color-picker-rows, 5) * var(--color-swatch-size) + (var(--color-picker-rows, 5) - 1) *
            var(--_color-picker-grid-gap)
    );

    gap: var(--_color-picker-grid-gap);
    margin: 0;
    padding: 0;

    border: none;
    overflow: auto;
    scrollbar-gutter: stable;
    scrollbar-width: thin;
    pointer-events: all;
`,f=r.div`
    display: grid;
    grid-template-columns: auto minmax(7rem, 1fr);
    justify-content: stretch;
    align-items: center;
    gap: ${o.xx_small} ${o.x_small};
`,h=r(i)`
    display: contents;

    & > [role='alert'] {
        grid-column: 2;
    }
`,v=r.footer`
    display: flex;
    gap: ${o.small};
`;export{m as a,g as b,x as c,w as d,f as e,h as f,v as g};
//# sourceMappingURL=ninox-components-ZKJZIHFD.js.map